import type { PostContent } from '../api/createPost'

// Signature matches the other platform postContent helpers
// ({ url, file: { type } }) so a single workspace-derived uploadUrls list can
// flow through any of the 5 builders. Only `file.type` is read here; `key`
// was never used.
export const postContent = (
  uploadUrls: { url: string; file: { type: string } }[],
  description: string,
  title: string,
): PostContent | { type: 'invalid'; reason: string } => {
  if (uploadUrls.length === 0) {
    return { type: 'invalid', reason: 'YouTube posts must have at least one video file' }
  }

  if (uploadUrls.length === 1) {
    if (uploadUrls[0]!.file.type.startsWith('video/')) {
      return {
        type: 'video', // Always 'video' - YouTube automatically detects if it's a Short
        url: uploadUrls[0]!.url,
        title: title,
        description: description,
      }
    }

    return { type: 'invalid', reason: 'YouTube posts can only contain videos' }
  }

  return { type: 'invalid', reason: 'YouTube posts can only contain one video file' }
}
